import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CheckOutlineSvg } from "../../../assets/landingPages/tick-circle.svg";
import { ReactComponent as CheckFillSvg } from "../../../assets/landingPages/tick-circle-filled.svg";
import { ReactComponent as MostPopular } from "../../../assets/landingPages/homePage/mostPopular.svg";
import { ReactComponent as MostPopularAr } from "../../../assets/landingPages/homePage/mostPopuAr.svg";

import { gettingPaymentsPalnsList } from "../../../redux/slices/paymentStripes/paymentStripesSlice";
import { useNavigate } from "react-router-dom";
import useLocales from "../../../hooks/useLocales";
import useSettings from "../../../hooks/useSettings";

const PricingHomePage = () => {
  const { darkMode } = useSelector((state) => state.theme);

  const { themeDirection } = useSettings();
  const { translate, currentLang } = useLocales();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [planPeriod, setPlanPeriod] = useState("month");
  const planPeriodSetter = (planPeriod) => {
    setPlanPeriod(planPeriod);
  };
  const [plans, setPlans] = useState();

  const getPaymentStripeData = useSelector(
    (state) => state?.paymentStripes?.getPaymentsPlansList
  );

  useEffect(() => {
    gettingPaymentsPlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const gettingPaymentsPlans = () => {
    dispatch(gettingPaymentsPalnsList());
  };
  useEffect(() => {
    if (getPaymentStripeData?.status === "success") {
      setPlans(
        getPaymentStripeData.result?.filter(
          (plan) =>
            plan.name === "Free Plan" || plan.name === "Premium Plan (Paid)"
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getPaymentStripeData?.status === "success"]);

  return (
    <>
      <div className="relative px-3 smm:px-6 xsmfold:pt-12 pt-28 py-12 lg:py-14 xl:py-16 ">
        <div className="flex justify-center">
          <div className="text-center xl:px-14">
            <h1 className="text-custom_h4 sm:text-custom_h3 lg:text-custom_h2 mb-4 sm:mb-[26px] dark:text-color_v1_dark">
              {/* Simple plans for */}
              {translate("front_end_pages.pricing.simple_plans_for")}
              <span className="text-main_color">
                {" "}
                {/* everyone */}
                {translate("front_end_pages.pricing.everyone")}
              </span>
            </h1>
          </div>
        </div>
        <div className="flex justify-center px-6">
          <div className="mb-10 sm:mb-[60px] text-small1 sm:text-body_copy1 text-heading_color dark:text-color_v2_dark text-center max-w-2xl">
            {translate(
              "front_end_pages.pricing.choose_your_plan_get_amazing_discounts_cancel_anytime"
            )}
            {/*Choose your plan. Get amazing discounts. Cancel anytime. */}
          </div>
        </div>
        <div className="flex justify-center z-10">
          <div
            className={`dark:border-color_dark dark:border rounded-full flex px-[7px] p-[5px] bg-white dark:bg-dark-primary w-fit items-center z-10 ${
              darkMode ? "" : "shadow-shadow_1"
            }`}
          >
            <div
              onClick={() => planPeriodSetter("month")}
              className={`cursor-pointer transition ease-in-out -tracking-[0.2px] ${
                planPeriod === "month"
                  ? "py-[10px] px-[30px] rounded-full border border-heading_color dark:border-color_v2_dark text-heading_color dark:text-color_v2_dark text-small3_b sm:text-small1_bold"
                  : "py-[10px] px-[30px] rounded-full  text-dark_bg_v5 text-small3_b sm:text-small1_bold opacity-60"
              } `}
            >
              {/* Monthly */}
              {translate("descriptions.monthly")}
            </div>
            <div
              onClick={() => planPeriodSetter("annual")}
              className={`cursor-pointer transition ease-in-out -tracking-[0.2px] ${
                planPeriod === "annual"
                  ? "py-[10px] px-[30px] rounded-full border border-heading_color dark:border-color_v2_dark text-heading_color dark:text-color_v2_dark text-small3_b sm:text-small1_bold"
                  : "py-[10px] px-[30px] rounded-full  text-dark_bg_v5 text-small3_b sm:text-small1_bold opacity-60"
              } `}
            >
              {/* Annual */}
              {translate("annual")}
            </div>
          </div>
        </div>
        <div
          className={`flex flex-col lg:flex-row ${
            themeDirection === "rtl" ? "lg:flex-row-reverse" : ""
          } gap-[30px] md:gap-[33px] justify-center items-center py-12 lg:py-16 lg:pb-[124px] z-10`}
        >
          {plans?.map((item, i) => {
            return item?.name === "Free Plan" ? (
              <div
                key={i}
                className={`${
                  darkMode ? "" : "shadow-box_shadow_1"
                } w-full relative hover:scale-105 p-[25px] sm:p-[30px] rounded-2xl bg-white dark:bg-dark-secondary max-w-md md:max-w-md md:min-w-[27rem]`}
              >
                <div className="text-body_copy2_black text-body_copy1_color dark:text-color_v1_dark">
                  {translate("front_end_pages.pricing.free_plan")}
                </div>
                <div className="flex gap-2 mt-2.5 mb-[15px] items-center">
                  <div className="text-custom_h4 text-heading_color dark:text-color_v1_dark">
                    {planPeriod === "annual" && <>${item?.annual_price}</>}
                    {planPeriod === "month" && <>${item?.monthly_price}</>}
                  </div>
                </div>
                <div className="text-dark_bg_v5 dark:text-color_v2_dark text-small3 md:text-body_copy2 mb-[25px] md:mb-10 capitalize">
                  {/* {item?.description} */}
                  {translate("package_suitable_people")}
                </div>

                <div className="hidden md:block text-heading_color dark:text-color_v1_dark text-body_copy2_black mb-[15px]">
                  {/* What’s included: */}
                  {translate(
                    "front_end_pages.home_page.pricing_section.what_included"
                  )}
                </div>
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                    <CheckOutlineSvg />
                    {/* Unlimited Biolink Pages */}
                    {translate(
                      "front_end_pages.home_page.pricing_section.unlimited_biolink_pages"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                    <CheckOutlineSvg />
                    {/* Unlimited Biolink Blocks */}
                    {translate(
                      "front_end_pages.home_page.pricing_section.unlimited_biolink_blocks"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                    <CheckOutlineSvg />
                    {/* 25 Biolink Pages */}
                    {translate(
                      "front_end_pages.home_page.pricing_section.bio_pages"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                    <CheckOutlineSvg />
                    {/* SEO Features */}
                    {translate(
                      "front_end_pages.home_page.pricing_section.seo_feature"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                    <CheckOutlineSvg />
                    {/* Brandings */}
                    {translate(
                      "front_end_pages.home_page.pricing_section.brandings"
                    )}
                  </div>

                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-body_copy1_color dark:text-color_v2_dark">
                    <CheckOutlineSvg />
                    {/* 24*7 Customer Support */}
                    {translate(
                      "front_end_pages.home_page.pricing_section.customer_support"
                    )}
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/pricing/payment/PaymentDetailsFormPage/${planPeriod}/${item?.product_id?._id}`
                    );
                  }}
                  className="w-full text-center mt-[25px] py-[6px] md:pt-[13px] md:pb-[12px] text-white rounded-full bg-gradient-to-br from-[#f8765c] to-[#f7554b] text-small3_b md:text-small1_bold uppercase"
                >
                  {translate("choose_plan")}
                </button>
              </div>
            ) : null;
          })}
          {plans?.map((item, i) => {
            return item?.name === "Premium Plan (Paid)" ? (
              <div
                key={i}
                className={`${
                  darkMode ? "" : "shadow-box_shadow_1"
                } w-full relative hover:scale-105 p-[25px] sm:p-[30px] rounded-2xl bg-gradient-to-br from-[#f8765c] to-[#f7554b] text-white max-w-md md:max-w-md md:min-w-[27rem]`}
              >
                {currentLang?.value !== "ar" ? (
                  <MostPopular className="absolute hidden lg:block lg:-top-[5.6rem] xl:-top-20 2xl:-top-20 lg:-right-8 xl:-right-24 2xl:-right-32 lg:max-h-28 xl:max-h-28 2xl:max-h-28 lg:max-w-[6.5rem] xl:max-w-fit 2xl:max-w-full lg:-rotate-12 xl:rotate-0" />
                ) : (
                  <MostPopularAr className="absolute hidden lg:block lg:-top-[5.6rem] xl:-top-20 2xl:-top-20 lg:-right-8 xl:-right-24 2xl:-right-36 lg:max-h-28 xl:max-h-28 2xl:max-h-[110px] lg:max-w-[6.5rem] xl:max-w-fit 2xl:max-w-full lg:-rotate-12 xl:rotate-0" />
                )}

                <div className="text-body_copy2 mb-2 text-white">
                  {translate("front_end_pages.pricing.premium_plan_paid")}
                </div>
                <div className="flex gap-2 mb-[15px] items-center">
                  <div className="text-custom_h4">
                    {planPeriod === "annual" && <>${item?.annual_price}</>}
                    {planPeriod === "month" && <>${item?.monthly_price}</>}
                  </div>
                </div>
                <div className="text-white text-small3 md:text-body_copy2 mb-[25px] md:mb-10 capitalize">
                  {item?.description}
                </div>

                <div className="hidden md:block text-body_copy2_black mb-[15px]">
                  {/* What’s included: */}
                  {translate(
                    "front_end_pages.home_page.pricing_section.what_included"
                  )}
                  :
                </div>
                <div className="flex flex-col gap-2.5">
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                    <CheckFillSvg />
                    {translate(
                      "front_end_pages.home_page.pricing_section.unlimited_biolink_pages"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                    <CheckFillSvg />
                    {translate(
                      "front_end_pages.home_page.pricing_section.unlimited_biolink_blocks"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                    <CheckFillSvg />
                    {translate(
                      "front_end_pages.home_page.pricing_section.bio_pages"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                    <CheckFillSvg />
                    {translate(
                      "front_end_pages.home_page.pricing_section.seo_feature"
                    )}
                  </div>
                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                    <CheckFillSvg />
                    {translate(
                      "front_end_pages.home_page.pricing_section.brandings"
                    )}
                  </div>

                  <div className="flex gap-1.5 items-center text-small3 md:text-small1 text-white">
                    <CheckFillSvg />
                    {translate(
                      "front_end_pages.home_page.pricing_section.customer_support"
                    )}
                  </div>
                </div>
                <button
                  onClick={() => {
                    navigate(
                      `/pricing/payment/PaymentDetailsFormPage/${planPeriod}/${item?.product_id?._id}`
                    );
                  }}
                  className="w-full text-center mt-[25px] py-[6px] md:pt-[13px] md:pb-[12px] text-heading_color rounded-full bg-white text-small3_b md:text-small1_bold uppercase"
                >
                  {translate("choose_plan")}
                </button>
              </div>
            ) : null;
          })}
        </div>
      </div>
    </>
  );
};

export default PricingHomePage;
